import * as React from "react";
import * as Dropzone from "react-dropzone/dist";
import { formatMessage } from "lib/globalize-util";
import ImageIcon from "components/icons/image";
import AddIcon from "material-ui/svg-icons/content/add";
import { merge, $, media } from "glamor";
import theme, { rawTheme } from "styles/theme";
import { fromJS, List, Map } from "immutable";
import CircularProgress from "material-ui/CircularProgress";
import { Item, NUMBER_FORMAT_CURRENCY_SYMBOL } from "constants/product-collection";
import BookmarkIcon from "material-ui/svg-icons/action/turned-in";
import IconButton from "material-ui/IconButton";
import { ZoomInIcon } from "components/icons/zoom-in";
import ProductImagesLightbox from "components/item/product-images-lightbox";
import TrashIcon from "components/icons/trash";
import { DATATEST } from "constants/integration";
import { ProductDisplayFields } from "./product-display-fields";
import { Totals } from "./totals";
import FlatButton from "material-ui/FlatButton";
import Eye from "components/icons/eye";
import { LinkProducts } from "./link-products";
import {
    IDisplayFields,
    getInOrFormula,
    getCollectionSwatch,
    formatAssortmentPrice,
    IDisplayField,
} from "helpers/product-collection";
import { get } from "lodash";
import { amphibiousGet, amphibiousGetIn } from "helpers/objUtils";
import classNames from "classnames";
import { ICurrency } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { getBrandNameForItem } from "helpers/collection";
import { buildServerRollupRowNodeId, ISnapshotItem } from "helpers/server-rollup";
import { GridApi } from "ag-grid-community";
import { safeParseFloat } from "lib/number";
export const DATA_DIR = "data-dir";

export interface IProps {
    collectionId: string;
    fieldLookup: string; // target key to in the item data we're interested in. e.g. images_1
    itemId?: string;
    onCreateCollectionAsset: any;
    onMutateCollectionItem: any;
    readOnly: boolean;
    items?: any;
    itemsId: string;
    deleteImageModalOpen?: boolean;
    onOpenDeleteImageModal?: () => void;
    setSelectedImage: any;
    selectedImageUrl?: string;
    isCollectionUploading: boolean;
    getSelectedImageUrl: any;
    onOpenDeleteConfirmation: (itemsid, itemIndex) => void;
    onLinkProductToItem?: (itemId) => void;
    router: any;
    onOpenProductModalOnProduct: (productId: string) => void;
    brandEntities: any;
    detailFields: IDisplayFields;
    orderedItems?: List<any>;
    merchantCurrency: ICurrency;
    isRollupMode?: boolean;
    canShopBrand?: boolean;
    itemDisplayProperty?: List<any>;
    snapshotItems?: Map<string, ISnapshotItem>;
    isServerRollup?: boolean;
    itemCollectionId?: string;
    rootGridApi?: GridApi;
}

interface IState {
    lightboxIsOpen: boolean;
    hover?: boolean;
}

export class ProductCollectionItem extends React.PureComponent<IProps, IState> {
    styles = merge(
        $(" .uploadedImagesContainer", {
            backgroundColor: theme.palette.lightestGrey,
            margin: "30px 0 10px 0",
            borderRadius: "3px",
            flex: 1,
            width: "100%",
        }),
        $(" .additional_image_urls", {
            width: "50px",
            height: "50px",
            backgroundSize: "cover",
            flex: "0 0 auto",
        }),
        $(" .image_urls", {
            height: "80px",
            width: "50px",
            backgroundSize: "contain",
        }),
        $(" .rightSection", {
            maxWidth: "550px",
            flex: "auto",
            flexGrow: 1,
            flexShrink: 1,
        }),
        $(" .productWrapper", {
            display: "flex",
            height: "460px",
            width: "100%",
            marginBottom: "30px",
            justifyContent: "space-evenly",
        }),
        $(" .leftSection", {
            flexGrow: 0,
            flexShrink: 0,
        }),
        $(" .topFields", {
            height: "234px",
            display: "flex",
        }),
        $(" .bottomFields", {
            display: "flex",
        }),
        $(" .totalsContainer", {
            flex: 1,
            marginLeft: "20px",
            position: "relative",
        }),
        $(" .notes", {
            flex: 1,
        }),
        $(" .notesTitle", {
            lineHeight: "20px",
            marginBottom: "10px",
            fontWeight: "bold",
            color: theme.palette.textColor,
        }),
        $(" .notesText", {
            border: `1px solid ${theme.palette.borderColor}`,
            borderRadius: "3px",
            padding: "16px 8px",
            color: theme.palette.textColor,
            minHeight: "104px",
        }),
        $(" .uploadedList", {
            display: "flex",
        }),
        $(" .imageContainer img", {
            width: "100%",
            height: "100%",
            objectFit: "contain",
        }),
        $(" .imageContainer svg", {
            width: "100%",
        }),
        $(" .imageContainer.noImage", {
            width: "400",
        }),
        $(" .imageContainer .imageSideBar", {
            maxHeight: "360px",
            overflow: "visible",
            display: "inline-block",
            width: "50px",
            verticalAlign: "top",
        }),
        $(" .imageContainer.noImage .imageSideBar", {
            display: "none",
        }),
        media(
            "(max-width: 900px)",
            $(" .imageContainer", {
                maxWidth: "300px",
            }),
            $(" .imageContainer.noImage", {
                width: "300px",
            })
        ),
        media(
            "(max-width: 768px)",
            $(" .productWrapper", {
                display: "block",
                height: "auto",
            }),
            $(" .leftSection", {
                width: "100%",
                padding: "0",
            }),
            $(" .rightSection", {
                paddingTop: "18px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "initial",
            }),
            $(" .imageContainer", {
                margin: "0 auto",
                maxWidth: "470px",
            }),

            $(" .topFields, .bottomFields", {
                display: "block",
                height: "auto",
            }),
            $(" .bottomFields", {
                order: -1,
            }),
            $(" .totalsContainer", {
                margin: "0 0 8px",
            }),
            $(" .viewDetails", {
                position: "static !important",
                marginTop: "8px !important",
                width: "100% !important",
            })
        )
    );

    muiStyles = {
        contentContainer: {
            display: "flex",
            flexWrap: "wrap",
        },
        iconButton: {
            width: "25px",
            padding: "12px 0",
        },
        imageSection: {
            display: "flex",
            flexWrap: "wrap",
        },
        imageContainer: {
            width: "240px",
            height: "360px",
            margin: "0 10px",
            border: `2px solid ${theme.palette.borderColor}`,
            position: "relative",
            display: "inline-block",
        },
        noImageIcon: {
            height: "360px",
            width: "120px",
            display: "block",
            margin: "0 auto",
            color: `${theme.palette.grey} !important`,
        },
        noImageThumbnailIcon: {
            height: "50px",
            display: "block",
            margin: "0 auto",
            color: `${theme.palette.grey} !important`,
        },
        thumbnail: {
            margin: "0 5px 10px 0",
        },
        thumbnailPlaceholder: {
            backgroundColor: theme.palette.borderColor,
            border: `2px dashed ${theme.palette.grey}`,
            width: "50px",
            height: "50px",
            margin: "0 5px 10px 0",
            position: "relative",
        },
        separator: {
            margin: "10px 10px 10px 0",
            borderTop: "1px solid black",
        },
        uploadedImagesLabel: {
            padding: "12px 0px 0px 8px",
            fontWeight: "bold",
            color: theme.palette.textColor,
        },
        uploadBox: {
            margin: "10px 0 0 10px",
        },
        uploadedImagesLabelAlt: {
            margin: "10px 0 10px 83px",
        },
        userImagesContainer: {
            display: "flex",
            margin: "10px 5px 0px 8px",
            cursor: "pointer",
            overflowX: "scroll",
        },
        bookmarkContainer: {
            position: "absolute",
            backgroundColor: "#fff",
            top: "6px",
            width: "48px",
            left: "6px",
            borderRadius: "50%",
            boxShadow: "3px 3px 20px 0px rgba(45,45,45,0.3)",
        },
        trashIconContainer: {
            position: "absolute",
            backgroundColor: "#fff",
            top: "6px",
            width: "48px",
            right: "6px",
            borderRadius: "50%",
            boxShadow: "3px 3px 20px 0px rgba(45,45,45,0.3)",
        },
        trashIcon: {
            paddingLeft: "15px",
        },
        zoomButtonContainer: {
            position: "absolute",
            backgroundColor: "#fff",
            bottom: "6px",
            width: "48px",
            right: "6px",
            borderRadius: "50%",
            boxShadow: "3px 3px 20px 0px rgba(45,45,45,0.3)",
        },
        selectedImageContainer: {
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
        },
        dropzone: {
            position: "absolute",
            top: "0px",
            width: "100%",
            height: "100%",
            border: "none",
        },
        circularProgress: {
            position: "absolute",
            top: "9px",
            left: "8px",
        },
        detailsButtonLabelStyle: {
            textDecoration: "underline",
        },
        detailsButtonStyle: {
            position: "absolute" as any,
            top: "215px",
            right: "0px",
        },
    };

    _dropzone: any;

    constructor(props: any) {
        super(props);

        this.state = {
            lightboxIsOpen: false,
        };
    }

    setDropzoneRef = (ref) => {
        this._dropzone = ref;
    };

    handleOpenDeleteDialog = () => {
        this.props.onOpenDeleteImageModal();
    };

    handleOpenLightbox = () => {
        this.setState({ lightboxIsOpen: true });
    };

    handleCloseLightbox = () => {
        this.setState({
            lightboxIsOpen: false,
            hover: false,
        });
    };

    handleSelectImage = (selectedImageUrl: string) => {
        this.props.setSelectedImage(selectedImageUrl);
    };

    getImageValues(key: string) {
        const { itemId } = this.props;

        const item = this.getRowById(itemId);
        const rowCSV = item && item.getIn(["fields", key, "string_value"]);
        if (rowCSV) {
            return rowCSV.split(",");
        }
        return [];
    }

    getImages(key: string) {
        const { readOnly, isCollectionUploading, getSelectedImageUrl } = this.props;
        const selectedImageUrl = getSelectedImageUrl();
        const uploading = isCollectionUploading;
        const images = [];
        const imageUrls = this.getImageValues(key);

        imageUrls.forEach((url, i) => {
            const matchingUrl = url && selectedImageUrl && selectedImageUrl === url;
            const imageStyle = {
                ...this.muiStyles.thumbnail,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundImage: `url(${url}?max_dimension=90)`,
                cursor: "pointer",
                border: matchingUrl ? `1px solid ${theme.palette.blue}` : `1px solid ${theme.palette.borderColor}`,
            };

            images.push(
                <div
                    className={key}
                    data-test={`${key}-${DATATEST.ASSORTMENTS.CDP.ADDITIONAL_IMAGE}${i}`}
                    key={`${key}_${i}`}
                    style={imageStyle}
                    onClick={this.handleSelectImage.bind(this, url)}
                />
            );
        });

        if (key === "additional_image_urls" && !readOnly) {
            images.unshift(
                <div key={"image_placeholder"} style={this.muiStyles.thumbnailPlaceholder as any}>
                    {!uploading && <AddIcon style={this.muiStyles.noImageThumbnailIcon} />}
                    {uploading && <CircularProgress size={30} style={this.muiStyles.circularProgress as any} />}
                    {!uploading && (
                        <Dropzone
                            data-test={DATATEST.ASSORTMENTS.CDP.IMAGE_UPLOAD}
                            ref={this.setDropzoneRef}
                            style={this.muiStyles.dropzone}
                            multiple={false}
                            onDropRejected={this.handleDropReject}
                            onDrop={this.handleDrop.bind(this, images.length + 1)}
                            accept="image/jpeg,image/jpg,image/png"
                        />
                    )}
                </div>
            );
        }

        return images;
    }

    getInitialIndex() {
        const { selectedImageUrl } = this.props;
        if (!selectedImageUrl) {
            return 0;
        }

        const images = this.getImageValues("image_urls").concat(this.getImageValues("additional_image_urls"));

        return images.indexOf(selectedImageUrl);
    }

    handleDropReject = () => {
        // intentionally blank, is required by dropzone but we don't really need it
    };

    handleSetPrimaryImage = () => {
        const { itemId, itemsId, getSelectedImageUrl } = this.props;
        const selectedImageUrl = getSelectedImageUrl();
        let item = this.getRowById(itemId);
        if (!item) {
            return;
        }
        item = item.toJS();
        const existingValue = item.fields.image_url ? item.fields.image_url.string_value : "";

        if (existingValue === selectedImageUrl) {
            delete item.fields.image_url;
        } else {
            item.fields.image_url = { string_value: selectedImageUrl };
        }

        const index = this.getRowIndexById(itemId);

        item = fromJS(item);
        this.props.onMutateCollectionItem(itemsId, index, item);
    };

    handleDrop = (index, acceptedFiles) => {
        const { readOnly, collectionId, itemId, itemsId } = this.props;
        if (!acceptedFiles.length || readOnly) {
            return; // no accepted files passed
        }

        const fileData = acceptedFiles[0];
        const reader = new FileReader();
        reader.readAsDataURL(fileData);

        reader.onload = (event) => {
            const uploadData = {
                content_type: fileData.type,
                filename: fileData.name,
                filesize_byte: fileData.size,
            };

            const itemIndex = this.getRowIndexById(itemId);
            const item = this.getRowById(itemId);

            this.props.onCreateCollectionAsset(
                collectionId,
                uploadData,
                fileData,
                item.get("fields").toJS(),
                itemIndex,
                itemsId,
                "additional_image_urls",
                index
            );
        };
    };

    /**
     * Helper function to get column value from main grid. This will help getting cached value instead of recomputing it.
     * If this is rollup, it will default to old implementation
     * @param data row data
     * @param displayField display object that contains field and formula information
     * @param isServerRollup
     * @returns
     */
    getPriceFieldValue = (data, displayField?: IDisplayField, isServerRollup?: boolean) => {
        if (isServerRollup) {
            return getInOrFormula(displayField, data, isServerRollup);
        }

        const { rootGridApi, itemId } = this.props;
        if (rootGridApi && displayField) {
            const fieldName = amphibiousGet(displayField.field, "field_name");
            const rowNode = rootGridApi.getRowNode(itemId);

            if (rowNode) {
                const value = rootGridApi.getValue(fieldName, rowNode);
                return safeParseFloat(value, 0);
            }
        }

        return 0;
    };

    handleGenerateDisplayFields = (data, detailFields, merchantCurrency) => {
        if (!data) {
            return {};
        }
        const { isServerRollup } = this.props;
        const { is_cost, is_retail, is_title, is_subtitle, is_total_units, is_total_retail, is_total_cost } =
            detailFields;
        const wholesaleValue = this.getPriceFieldValue(data, is_cost, isServerRollup);
        const retailValue = this.getPriceFieldValue(data, is_retail, isServerRollup);
        const wholesaleSymbol = is_cost && get(is_cost.field, NUMBER_FORMAT_CURRENCY_SYMBOL);
        const retailSymbol = is_retail && get(is_retail.field, NUMBER_FORMAT_CURRENCY_SYMBOL);
        const totalRetailValue = this.getPriceFieldValue(data, is_total_retail, isServerRollup);
        const totalCostValue = this.getPriceFieldValue(data, is_total_cost, isServerRollup);

        const totalCostSymbol = merchantCurrency?.symbol || "";
        const totalRetailSymbol = merchantCurrency?.symbol || "";

        const totalCostDisplay = formatAssortmentPrice(totalCostValue, totalCostSymbol);
        const totalRetailDisplay = formatAssortmentPrice(totalRetailValue, totalRetailSymbol);
        const retailPriceDisplay = formatAssortmentPrice(retailValue, retailSymbol);
        const wholesalePriceDisplay = formatAssortmentPrice(wholesaleValue, wholesaleSymbol);

        return {
            productName: is_title && data.getIn(is_title.path),
            styleNumber: is_subtitle && data.getIn(is_subtitle.path),
            retailPrice: retailPriceDisplay,
            wholesalePrice: wholesalePriceDisplay,
            totalUnitsValue: this.getPriceFieldValue(data, is_total_units, isServerRollup),
            totalUnitsLabel: is_total_units && get(is_total_units.field, "display_name"),
            totalRetailValue: totalRetailDisplay,
            totalRetailLabel: is_total_retail && get(is_total_retail.field, "display_name"),
            totalCostLabel: is_total_cost && get(is_total_cost.field, "display_name"),
            totalCostValue: totalCostDisplay,
        };
    };

    render() {
        const { lightboxIsOpen } = this.state;
        const {
            readOnly,
            fieldLookup,
            itemId,
            getSelectedImageUrl,
            router,
            onOpenProductModalOnProduct,
            onLinkProductToItem,
            brandEntities,
            detailFields,
            merchantCurrency,
            isRollupMode,
            canShopBrand,
            itemDisplayProperty,
        } = this.props;

        if (!itemId) {
            return null;
        }
        const matchingItem = this.getRowById(itemId);
        const productDetailsValues = this.handleGenerateDisplayFields(matchingItem, detailFields, merchantCurrency);
        const selectedImageUrl = getSelectedImageUrl();
        const images = this.getImageValues("image_urls").concat(this.getImageValues("additional_image_urls"));
        const productImages = this.getImages("image_urls");
        const uploadedImages = this.getImages("additional_image_urls");
        const selectedImageStyle: any = {
            ...this.muiStyles.selectedImageContainer,
        };

        if (selectedImageUrl) {
            selectedImageStyle.backgroundImage = `url(${selectedImageUrl}${
                selectedImageUrl.includes("?") ? "&" : "?"
            }max_dimension=440)`;
        }

        const matchingItemProductId = matchingItem && matchingItem.getIn(Item.FIELDS.PRODUCT_ID);
        // necessary for stubbing in product-lightbox
        matchingItem.__images = images.map((url) => `${url}${url.includes("?") ? "&" : "?"}max_dimension=1200`);
        matchingItem.getImageSrc = (index) => {
            return matchingItem.__images[index];
        };
        const selectedImageIsProductImage = this.getImageValues("image_urls").includes(selectedImageUrl);
        let selectedImageIsPrimaryImage = false;
        if (matchingItem.getIn(["fields", fieldLookup])) {
            selectedImageIsPrimaryImage =
                selectedImageUrl && selectedImageUrl === matchingItem.getIn(["fields", fieldLookup, "string_value"]);
        }

        const brandId = matchingItem && matchingItem.getIn(Item.FIELDS.BRAND_ID);
        const brandName = matchingItem && getBrandNameForItem(itemDisplayProperty, matchingItem);
        return (
            <div style={this.muiStyles.contentContainer as any} {...this.styles}>
                <div data-test={DATATEST.ASSORTMENTS.CDP.CART_DETAILS_CONTAINER} className="productWrapper">
                    <div className="leftSection">
                        <div className={classNames("imageContainer", { noImage: !selectedImageUrl })}>
                            <div className="imageSideBar">{productImages}</div>
                            <div style={this.muiStyles.imageContainer as any}>
                                {!selectedImageUrl && <ImageIcon style={this.muiStyles.noImageIcon} />}
                                {selectedImageUrl && (
                                    <img
                                        data-test={DATATEST.ASSORTMENTS.CDP.PRIMARY_IMAGE_DETAILS}
                                        src={selectedImageUrl}
                                    />
                                )}

                                {matchingItem.__images.length > 0 && (
                                    <div style={this.muiStyles.zoomButtonContainer as any}>
                                        <IconButton
                                            data-test={DATATEST.ASSORTMENTS.CDP.ZOOM_IMAGE}
                                            onClick={this.handleOpenLightbox}
                                        >
                                            <ZoomInIcon
                                                color={rawTheme.palette.darkGrey}
                                                hoverColor={rawTheme.palette.darkerGrey}
                                            />
                                        </IconButton>
                                    </div>
                                )}

                                {matchingItem.__images.length > 0 && !selectedImageIsProductImage && !readOnly && (
                                    <div style={this.muiStyles.trashIconContainer as any}>
                                        <IconButton
                                            data-test={DATATEST.ASSORTMENTS.CDP.DELETE_IMAGE}
                                            onClick={this.handleOpenDeleteDialog}
                                            style={this.muiStyles.trashIcon as any}
                                            tooltip={formatMessage("Delete image")}
                                        >
                                            <TrashIcon />
                                        </IconButton>
                                    </div>
                                )}

                                {matchingItem.__images.length > 0 && !readOnly && (
                                    <div style={this.muiStyles.bookmarkContainer as any}>
                                        <IconButton
                                            data-test={DATATEST.ASSORTMENTS.CDP.SET_AS_PRIMARY_IMAGE}
                                            onClick={this.handleSetPrimaryImage}
                                            tooltip={formatMessage("Set as primary image")}
                                        >
                                            <BookmarkIcon
                                                color={
                                                    selectedImageIsPrimaryImage
                                                        ? theme.palette.blue
                                                        : theme.palette.textColor
                                                }
                                            />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="rightSection">
                        <div className="topFields">
                            <ProductDisplayFields
                                productName={productDetailsValues.productName}
                                styleNumber={productDetailsValues.styleNumber}
                                color={matchingItem && matchingItem.getIn(Item.FIELDS.COLOR)}
                                wholesalePrice={productDetailsValues.wholesalePrice}
                                retailPrice={productDetailsValues.retailPrice}
                                brandId={brandId}
                                productId={matchingItemProductId}
                                router={router}
                                colorSwatch={getCollectionSwatch(matchingItem)}
                                brandEntities={brandEntities}
                                brandNameOverride={!brandEntities?.[brandId] ? brandName : ""}
                                {...(canShopBrand && !!brandEntities?.[brandId]
                                    ? { onClickProductName: onOpenProductModalOnProduct }
                                    : {})}
                            />
                            <div className="totalsContainer">
                                <Totals
                                    totalUnitsValue={productDetailsValues.totalUnitsValue}
                                    totalUnitsLabel={productDetailsValues.totalUnitsLabel}
                                    totalRetailLabel={productDetailsValues.totalRetailLabel}
                                    totalRetailValue={productDetailsValues.totalRetailValue}
                                    totalCostLabel={productDetailsValues.totalCostLabel}
                                    totalCostValue={productDetailsValues.totalCostValue}
                                />
                                {matchingItemProductId &&
                                    canShopBrand &&
                                    !isRollupMode &&
                                    !!brandEntities?.[brandId] && (
                                        <FlatButton
                                            label={formatMessage("View style details")}
                                            icon={<Eye />}
                                            className="viewDetails"
                                            style={this.muiStyles.detailsButtonStyle}
                                            labelStyle={this.muiStyles.detailsButtonLabelStyle}
                                            onClick={onOpenProductModalOnProduct.bind(this, matchingItemProductId)}
                                        />
                                    )}
                            </div>
                        </div>
                        <div className="bottomFields">
                            {uploadedImages.length > 0 && (
                                <div className="uploadedImagesContainer">
                                    <div style={this.muiStyles.uploadedImagesLabel as any}>
                                        {formatMessage("Your Photos:")}
                                    </div>
                                    <div className="uploadedList">
                                        <div style={this.muiStyles.uploadBox as any}>{uploadedImages[0]}</div>
                                        <div style={this.muiStyles.userImagesContainer as any}>
                                            {uploadedImages.slice(1)}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {!readOnly && <LinkProducts item={matchingItem} onLinkProductToItem={onLinkProductToItem} />}
                <ProductImagesLightbox
                    open={lightboxIsOpen}
                    item={matchingItem}
                    onClose={this.handleCloseLightbox}
                    fullWidth={true}
                    initialIndex={this.getInitialIndex()}
                    noDownloads={true}
                />
            </div>
        );
    }

    private getRowIndexById = (id, items = this.props.items) => {
        // gets row index determined by collection not ag-grid
        return items?.findIndex((item) => amphibiousGetIn(item, Item.FIELDS.ID) === id);
    };

    private getRowById = (id) => {
        const { isServerRollup, snapshotItems, itemCollectionId } = this.props;
        if (isServerRollup) {
            return snapshotItems.get(buildServerRollupRowNodeId(id, itemCollectionId));
        }
        // gets row index determined by collection not ag-grid
        const rowIndex = this.getRowIndexById(id);
        if (rowIndex >= 0) {
            return this.props.items.get(rowIndex);
        }
        return null;
    };
}
